var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"value":_vm.tabIndex}},[_c('vs-tab',{attrs:{"label":"4.4.4 점검"},on:{"click":function($event){return _vm.moveTab('safety_check_444')}}},[_c('safety-check444-index')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }